import PriceCatalogTable from './PriceCatalogTable';

export default PriceCatalogTable;
